import { Banner } from '@web_opxp/components';
import {
  ETagType,
  FirebaseSelectors,
  RemoteConfigService,
  renderStringToReact,
  useTranslation,
} from '@web_opxp/features';
import { FC } from 'react';
import { connect } from 'react-redux';
import * as ENV from '../base/env';
import { AssetsBaseUrl } from '../base/env';
import { getMedRecruitmentLink } from '../base/utils';
import { IState } from '../store/state';
import { canBannerBeShown, closeMedBanner } from './medBannerService';
import { medBannerClickedAction, medBannerClosedAction } from './medBannerTrackingActions';
import './medPatientsBanner.scss';

export interface IMedPatientsBannerProps {
  show: boolean;
  onClick: () => void;
  onClose: () => void;
}

export const MedPatientsBannerFC: FC<IMedPatientsBannerProps> = ({ show, onClick, onClose }) => {
  const { language, t } = useTranslation();
  const content = renderStringToReact(t('prereg:MedPatientsBanner.TextHtml'), ETagType.div, 'med-banner-title');
  const blogLink = getMedRecruitmentLink();
  const medIconUrl = `${AssetsBaseUrl}/feature/icons/icon-med.svg`;
  const closeHandler = () => {
    // save close timestamp
    closeMedBanner();
    // track close event on firebase
    onClose();
  };
  return (
    <Banner show={show && language === 'de'} color="blue" onClose={closeHandler}>
      <a href={blogLink} target="_blank" rel="noreferrer" onClick={onClick}>
        <div className="banner-inner-container">
          <img alt="med icon" className="med-icon" src={medIconUrl} />
          {content}
        </div>
      </a>
    </Banner>
  );
};

export const mapStateToProps = (state: IState) => {
  let show = false;
  const isFirebaseReady = FirebaseSelectors.isReady(state);
  if (isFirebaseReady) {
    const enabled = RemoteConfigService.getBooleanConfigValue(ENV.RemoteConfigMedPatientsBanner, false);
    if (enabled) {
      // only check timeout if enabled in firebase
      show = canBannerBeShown();
    }
  }
  return { show };
};

export const mapDispatchToProps = {
  onClick: medBannerClickedAction,
  onClose: medBannerClosedAction,
};

const MedPatientsBanner = connect(mapStateToProps, mapDispatchToProps)(MedPatientsBannerFC);
export default MedPatientsBanner;
